import { render, staticRenderFns } from "./VProjectSuggest.vue?vue&type=template&id=85ce1964&"
import script from "./VProjectSuggest.vue?vue&type=script&lang=js&"
export * from "./VProjectSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports